var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.isAdminGroup ? ['LKAdmin'] :['LKAdmin','LK']}},[_c(_vm.componentNameCalc,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }